import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';

import { Grid } from '../../../lib/grid';
import { DataSource } from '../../../lib/data-source/data-source';
import { Column } from '../../../lib/data-set/column';

@Component({
    selector: '[ng2-st-thead-filters-row]',
    template: `
    <th *ngIf="isMultiSelectVisible"></th>
    <th
      ng2-st-add-button
      *ngIf="showActionColumnLeft"
      [grid]="grid"
      [source]="source"
      (add)="add.emit($event)"
    ></th>
    <th
      *ngFor="let column of grid.getColumns()"
      class="ng2-smart-th {{ column.id }}"
      id="filter-{{ column.id }}"
    >
      <ng2-smart-table-filter
        [source]="source"
        [column]="column"
        [inputClass]="filterInputClass"
        (filter)="filter.emit($event)"
      >
      </ng2-smart-table-filter>
    </th>
    <th
      ng2-st-add-button
      *ngIf="showActionColumnRight"
      [grid]="grid"
      [source]="source"
      (add)="add.emit($event)"
    ></th>
  `,
    standalone: false
})
export class TheadFitlersRowComponent implements OnChanges {
  @Input() public grid: Grid;
  @Input() public source: DataSource;

  @Output() public add = new EventEmitter<any>();
  @Output() public create = new EventEmitter<any>();
  @Output() public filter = new EventEmitter<any>();

  public isMultiSelectVisible: boolean;
  public showActionColumnLeft: boolean;
  public showActionColumnRight: boolean;
  public filterInputClass: string;

  public ngOnChanges() {
    this.isMultiSelectVisible = this.grid.isMultiSelectVisible();
    this.showActionColumnLeft = this.grid.showActionColumn('left');
    this.showActionColumnRight = this.grid.showActionColumn('right');
    this.filterInputClass = this.grid.getSetting('filter.inputClass');
  }
}
